module.exports = __webpack_public_path__ + "AniketMukhi2d-e1ef6774.png";